import { Trans } from 'react-i18next';

import { annualDistancesLookup, dailyDistancesLookup } from '/business/shared/util/distances';

type DistanceCanonicalNameProps = {
  distance: number | string;
  type?: 'annual' | 'daily';
  unit: string;
  usesHighMileageDistances?: boolean;
};

function isNumeric(value: number | string) {
  return /^-?\d+$/.test(String(value));
}
function DistanceCanonicalName({
  distance,
  unit,
  type = 'daily',
  usesHighMileageDistances = false,
}: DistanceCanonicalNameProps) {
  const annualDistances = annualDistancesLookup(usesHighMileageDistances);
  const dailyDistances = dailyDistancesLookup();

  const distances = type === 'annual' ? annualDistances : dailyDistances;
  const distanceOptions = unit === 'km' || unit === 'miles' ? distances[unit] : undefined;
  const foundDistance = distanceOptions?.find(({ name }) => name === distance);
  if (!foundDistance) {
    if (isNumeric(distance)) {
      return `${distance.toLocaleString()} ${unit}`;
    }

    // @i18n: Cannot find distance
    return <Trans i18nKey="business:SiteComponents.distanceCanonicalName.distanceError" />;
  }
  return <>{foundDistance.displayName}</>;
}

export default DistanceCanonicalName;
